export const API_HOST = process.env.NODE_ENV === "production" ? "https://beta-servers.caralyst.io" : "http://localhost:3001";

const findOrg = () => {
    const url = new URL(window.location.href);
    const subdomain = url.hostname.split('.')[0]; // "my"
    const devOrg = subdomain === "localhost" ? "general-doctor" : subdomain === "wustl" ? "wustl-doctor" : null;
    const prodOrg = subdomain === "doc" ? "general-doctor" : subdomain === "wustl" ? "wustl-doctor" : null;
    const org = process.env.NODE_ENV === "production" ? prodOrg : devOrg;
    // uncomment next line to test wustl org
    // return "wustl"
    return org;
}
export const ORG = findOrg();
export const BASE_URL = window.location.href.includes("localhost") ? "http://localhost:4200" : "https://doc.caralyst.io";

export const COGNITO_MAP = {
    "auth_url": "https://rest.caralyst.io/cognito-service/auth-url",
    "logout_url": "https://rest.caralyst.io/cognito-service/logout-url",
    "refresh": "https://rest.caralyst.io/cognito-service/refresh",
    "revoke": "https://rest.caralyst.io/cognito-service/revoke",
    "add_group": "https://rest.caralyst.io/cognito-service/add-group",
    "s3_upload": "https://rest.caralyst.io/file-service/generate-presigned-url-doctor",
    "report_bug": "https://rest.caralyst.io/report-bug",
    "user_info": `https://rest.caralyst.io/cognito-service/${ORG}-patient/user-info`,
};

export const API_ROOT = "/api"
export const ROOT = API_HOST + API_ROOT;
